import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'rapider-tooltip',
  standalone: true,
  imports: [CommonModule, NzTooltipModule],
  template: `
    <span
      nz-tooltip
      [nzTooltipTitle]="text"
      [nzTooltipPlacement]="placement"
      [nzTooltipColor]="color"
      class="flex items-center justify-center w-full h-full"
    >
      <ng-content></ng-content>
    </span>
  `,
  host: {
    class: 'inline-flex items-center justify-center shrink-0',
  },
})
export class RapiderTooltipComponent {
  @Input() text: string = '';
  @Input() placement: 'top' | 'left' | 'right' | 'bottom' = 'top';
  @Input() color: string = '';
}
